var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":'各種設定',"data-test":"header"}}),_vm._v(" "),_c('div',{staticClass:"boss-admin-container clearfix"},[_c('sidebar'),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }